import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
import { HumanCapabilityModels } from '../components/HumanCapabilityModels';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-3081" data-mp="3k524pl9s6tzs" />
      <FramingBand data-id="element-3082" data-mp="3k4ai2zy5w6ln" />
      <HumanCapabilityModels data-id="element-3083" data-mp="3k5vc8ogkdniz" />
      <ProblemSection data-id="element-3084" data-mp="3k2zfh3ggd4w4" />
      <PlatformOverview data-id="element-3085" data-mp="3p4f04uepx9dz" />
      <OperatingModel data-id="element-3086" data-mp="3p3ws70ip16q8" />
      <CapabilityDomains data-id="element-3087" data-mp="3p2lsbbsdcj4e" />
      <HumanOpportunity data-id="element-3088" data-mp="3p2bzzhjupzvj" />
      <LifecycleArchitecture data-id="element-3089" data-mp="3tuloct5birvp" />
      <Solutions data-id="element-3090" data-mp="3tvwxz9lg2tuq" />
      <ProductEcosystem data-id="element-3091" data-mp="3twgaubw8ms1w" />
      <RelatedInitiative name="Cognocracy" body="Explore a proposed civic application of the Human Capability Framework and NCJI." href="/ecosystem/cognocracy" data-id="element-3092" data-mp="3twq202t0r596" />
      <GlobalArchitecture data-id="element-3093" data-mp="7prneqayx9jw" />
      <LeadershipReadiness data-id="element-3094" data-mp="bpifqyg57xqj" />
      <FAQ data-id="element-3095" data-mp="bqbk5srmqb5i" />
      <FinalCTA data-id="element-3096" data-mp="bps4yjtd60v6" />
    </>;
}